import { createContext, useState, useEffect, useCallback } from "react";

export const AuthContext = createContext({
  isAuthenticated: false,
  user: null,
  userRole: null,
  token: null,
  isLoading: true,
  login: () => {},
  logout: () => {},
});

const clearAuthCookies = () => {
  const cookieNames = ["T6hVzR7c0g3maM3F", "02hfCmUqpk66w4uG", "3F2Mb2pJ1YRro5Z4"];
  cookieNames.forEach((name) => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const login = useCallback((userData, tokenData, role) => {
    localStorage.setItem("userInfo", JSON.stringify(userData));
    localStorage.setItem("userRole", role);
    localStorage.setItem("authTokenContent", tokenData.content);

    setUser(userData);
    setUserRole(role);
    setToken(tokenData.content);
    setIsAuthenticated(true);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("userInfo");
    localStorage.removeItem("userRole");
    localStorage.removeItem("authTokenContent");

    clearAuthCookies();

    setUser(null);
    setUserRole(null);
    setToken(null);
    setIsAuthenticated(false);

    window.location.href = "/authentication/sign-in/basic";
  }, []);

  useEffect(() => {
    try {
      const storedUserInfo = localStorage.getItem("userInfo");
      const storedUserRole = localStorage.getItem("userRole");
      const storedTokenContent = localStorage.getItem("authTokenContent");

      if (storedUserInfo && storedUserRole && storedTokenContent) {
        setUser(JSON.parse(storedUserInfo));
        setUserRole(storedUserRole);
        setToken(storedTokenContent);
        setIsAuthenticated(true);
      }
    } catch (error) {
      console.error("Error loading auth state from localStorage:", error);
      setIsAuthenticated(false);
      setUser(null);
      setUserRole(null);
      setToken(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  if (isLoading) {
    return <div>Loading Authentication...</div>;
  }

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        user,
        userRole,
        token,
        isLoading,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
